import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  let imgPath = process.env.PUBLIC_URL + "assets/media/";
  let notFoundImg = imgPath + "not-found.png";
  return (
    <div
      className="pages-bg bg-white d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="">
        <img
          src={notFoundImg}
          className="img-fluid"
          alt="No image"
          width="450"
        />
      </div>
      <Link to="/" className="btn btn-outline-success">
        <i className="zmdi zmdi-arrow-left"></i>&nbsp;&nbsp;Return home
      </Link>
    </div>
  );
};

export default NotFound;
